<div class="card block card-photo">
    <div *ngIf="preview" class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Photo</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/photos.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div id="picturesCarousel-{{rand}}" class="carousel slide picturesCarousel" data-ride="carousel">
                <div class="carousel-inner">
                    <ng-container *ngIf="authenticationService.isAllowed('pro')">
                        <div *ngFor="let picture of favorite.pictures; index as i;"
                             [ngClass]="{'carousel-item': true, 'active': i == 0}">
                            <img *ngIf="!picture.includes('ubiflow')" (click)="zoom(i)" src="{{ picture }}" />
                            <img *ngIf="picture.includes('ubiflow')" (click)="zoom(i)" src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}" />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!authenticationService.isAllowed('pro')">
                        <div *ngFor="let picture of favorite.ad.pictures; index as i;"
                             [ngClass]="{'carousel-item': true, 'active': i == 0}">
                            <img *ngIf="!picture.includes('ubiflow')" (click)="zoom(i)" src="{{ picture }}" />
                            <img *ngIf="picture.includes('ubiflow')" (click)="zoom(i)" src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}" />
                        </div>
                    </ng-container>
                </div>

                <button *ngIf="favorite.pictures.length > 1" class="carousel-control-prev"
                        type="button"
                        [attr.data-bs-target]="'#picturesCarousel-' + rand"
                        data-bs-slide="prev">
                    <i class="fa fa-chevron-left"></i>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button *ngIf="favorite.pictures.length > 1" class="carousel-control-next"
                        type="button"
                        [attr.data-bs-target]="'#picturesCarousel-' + rand"
                        data-bs-slide="next">
                    <i class="fa fa-chevron-right"></i>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="card block isMinimizable minimize"
     *ngIf="authenticationService.isAllowed('pro') || favorite.ad_id === 0">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Ajouter / Supprimer des photos</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <div class="row addPictures">
            <div class="col-md-4">
                <input type="file" class="file-input"
                       [accept]="requiredFileType"
                       (change)="onFileSelected($event)" #fileUpload>

                <div class="file-upload">
                    <button class="upload-btn btn btn-light" (click)="fileUpload.click()">
                        <i class="fa fa-paperclip"></i> Ajouter une photo
                    </button>

                </div>
            </div>
            <div class="col-md-8">
                {{ fileName || "Aucun fichier sélectionné." }}
                <i class="fa fa-check text-green" [hidden]="this.done == false"></i>
                <i class="fa fa-close text-red" [hidden]="this.fail == false"></i>
                <div class="progress">
                    <mat-progress-bar class="progress-bar" mode="determinate" [value]="uploadProgress"
                                      *ngIf="uploadProgress">
                    </mat-progress-bar>
                </div>
            </div>
        </div>

        <h3>Trier les photos</h3>
        <div class="row" cdkDropListGroup>
            <div class="img-reorder col-10" cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
                 (cdkDropListDropped)="drop($event)">
                <div class="img-reorder-item" *ngFor="let picture of favorite.pictures" cdkDrag>
                    <div class="placeholder" *cdkDragPlaceholder></div>
                    <img src="{{ picture }}"/>
                </div>
            </div>
            <div class="col-2 img-trash" cdkDropList
                 [cdkDropListData]="[]"
                 (cdkDropListDropped)="drop($event)" id="trash">
                <i class="fa cfa cfa-trash"></i>
            </div>
        </div>

        <ng-container *ngIf="authenticationService.isAllowed('pro')">
            <h3 class="mt-4">Lien visite virtuel</h3>
            <div class="col-12">
                <mat-form-field>
                    <mat-label>Lien</mat-label>
                    <input class="text" matInput [(ngModel)]="favorite.visite_link" (ngModelChange)="edit($event)">
                </mat-form-field>
            </div>
        </ng-container>

    </div>
</div>
